import React from 'react';
import { cn } from '../../utils/cn';

// Custom spring animation
const springAnimation = `cubic-bezier(0.87, 0, 0.13, 1)`;

const Switch = React.forwardRef(({ className, checked, onCheckedChange, disabled, ...props }, ref) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      data-state={checked ? "checked" : "unchecked"}
      className={cn(
        `peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-all duration-300 ${springAnimation} focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 hover:shadow-md`,
        checked ? "bg-blue-600" : "bg-gray-300",
        className
      )}
      onClick={() => onCheckedChange?.(!checked)}
      disabled={disabled}
      ref={ref}
      {...props}
    >
      <span
        className={cn(
          `pointer-events-none block h-5 w-5 rounded-full bg-white shadow-lg ring-0 transition-all duration-300 ${springAnimation} transform scale-95 data-[state=checked]:scale-100 data-[state=checked]:shadow-md`,
          checked ? "translate-x-5" : "translate-x-0"
        )}
      />
    </button>
  );
});

Switch.displayName = "Switch";

export { Switch };
